import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Activity2 = function Activity2(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M15.707 13.53a1 1 0 0 0-1.414-1.414L11 15.41l-1.293-1.293a1 1 0 0 0-1.414 1.415l2 2a1 1 0 0 0 1.414 0l4-4Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 2.823a3.001 3.001 0 0 0-2.83 2H7a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-12a3 3 0 0 0-3-3h-1.17a3.001 3.001 0 0 0-2.83-2h-2Zm0 2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Zm6 2h-1.17a3.001 3.001 0 0 1-2.83 2h-2a3.001 3.001 0 0 1-2.83-2H7a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-12a1 1 0 0 0-1-1Z",
      fill: color
    })]
  });
};
export default Activity2;